import { useLayoutEffect, useState } from 'react';

// Returns the index of the first variant (hidden copies, most preferred first)
// whose width fits spaceRef, or variantRefs.length if none fits. Measuring real
// copies follows the actual font, and can't flip-flop at a boundary. spaceRef's
// width must not depend on its content (e.g. flex: 1 1 0; minWidth: 0).
const useFirstFittingVariant = (spaceRef, variantRefs, enabled = true) => {
  const [variantIndex, setVariantIndex] = useState(0);

  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const space = spaceRef.current;
    const copies = variantRefs.map((ref) => ref.current);
    if (!space || copies.some((copy) => !copy)) return undefined;

    const update = () => {
      const room = space.getBoundingClientRect().width;
      const index = copies.findIndex((copy) => copy.getBoundingClientRect().width <= room);
      setVariantIndex(index === -1 ? copies.length : index);
    };
    update();

    const observer = new ResizeObserver(update);
    observer.observe(space);
    copies.forEach((copy) => observer.observe(copy));
    return () => observer.disconnect();
    // Refs are stable; only `enabled` changes whether the measured elements exist.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return variantIndex;
};

export default useFirstFittingVariant;
